<template>
    <el-dialog
        width="750px"
        :title="userDepartmentPostTitle"
        :before-close="handleClickCancel"
        :close-on-press-escape="false"
        append-to-body
        class="custom-form-dialog"
        :close-on-click-modal="false"
        v-if="userDepartmentPostVisible"
        :visible.sync="userDepartmentPostVisible"
    >
        <div class="user_department_wrap">
            <div class="left_selectable_wrap">
                <div class="title_wrap">
                    <span
                        v-if="
                            selectType == 'departmentUserPost' ||
                            selectType == 'departmentUser' ||
                            selectType == 'departmentUserTag'
                        "
                        @click="handleClickTab('department')"
                        :class="type == 'department' ? 'active' : ''"
                        >部门</span
                    >
                    <span @click="handleClickTab('user')" :class="type == 'user' ? 'active' : ''">人员</span>
                    <span
                        v-if="selectType == 'departmentUserPost'"
                        @click="handleClickTab('post')"
                        :class="type == 'post' ? 'active' : ''"
                        >岗位</span
                    >
                    <span
                        v-if="selectType == 'departmentUserTag'"
                        @click="handleClickTab('tag')"
                        :class="type == 'tag' ? 'active' : ''"
                        >人员标签</span
                    >
                </div>
                <template v-if="type == 'post'">
                    <div class="check_box_block">
                        <el-checkbox-group @change="handleChangePost" v-model="post_selected_ids">
                            <el-checkbox :key="item.relate_id" :label="item.relate_id" v-for="item in postList">
                                {{ item.relate_name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </template>
                <template v-else-if="type == 'tag'">
                    <div style="padding: 0 15px 10px">
                        <el-input
                            @keyup.enter.native="getDepartmentAndUserList"
                            placeholder="请输入"
                            size="small"
                            v-model="keyWord"
                            clearable
                            @blur="getDepartmentAndUserList"
                            @clear="getDepartmentAndUserList"
                        >

                            <i slot="suffix" class="iconfont icon-sousuo" @click="getDepartmentAndUserList"></i>
                        </el-input>
                    </div>
                    <div class="check_box_block">
                        <el-checkbox-group v-model="tag_selected_ids">
                            <el-checkbox
                                @change="handleChangeTag($event, item)"
                                :key="item.relate_id"
                                :label="item.relate_id"
                                v-for="item in userTagList"
                            >
                                <span>{{ item.relate_name }}</span
                                ><span> ({{ item.users.length }}人)</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </template>
                <template v-else>
                    <div style="padding: 0 15px 0">
                        <el-input
                            @keyup.enter.native="getDepartmentAndUserList"
                            placeholder="请输入"
                            size="small"
                            v-model="keyWord"
                            clearable
                            @blur="getDepartmentAndUserList"
                            @clear="getDepartmentAndUserList"
                        >
                            <i slot="suffix" class="iconfont icon-sousuo" @click="getDepartmentAndUserList"></i>
                        </el-input>
                    </div>
                    <div class="scroll_wrap">
                        <el-tree
                            :data="selectable_list"
                            :default-expand-all="true"
                            :default-expanded-keys="default_expanded"
                            :expand-on-click-node="false"
                            :props="defaultProps"
                            @check="handleCheckNodeItem"
                            check-on-click-node
                            :check-strictly="localCheckStrictly"
                            node-key="relate_type_id"
                            ref="dep_and_user_tree"
                            show-checkbox
                        >
                        </el-tree>
                    </div>
                </template>
            </div>
            <div class="right_selected_wrap">
                <div class="title_wrap">
                    <div class="title">
                        <h5>已选</h5>
                        <span v-if="department_selected_list.length" v-text="department_selected_list.length + '个部门'"></span>
                        <span v-if="department_selected_list.length && user_selected_list.length">/</span>
                        <span v-if="user_selected_list.length" v-text="user_selected_list.length + '个人员'"></span>
                        <span v-if="tag_selected_list.length && (user_selected_list.length || user_selected_list.length)">/</span>
                        <span v-if="tag_selected_list.length" v-text="tag_selected_list.length + '个标签'"></span>
                    </div>
                    <div class="handle_clear" @click="handleClickClearSelected">
                        清除
                    </div>
                </div>
                <ul class="selected_list">
                    <li
                        :key="index"
                        class="selected_item"
                        v-for="(item, index) in type == 'department'
                            ? department_selected_list
                            : type == 'user'
                            ? user_selected_list
                            : type == 'post'
                            ? post_selected_list
                            : tag_selected_list"
                    >
                        <span v-text="item.relate_name"></span>

                        <el-button class="handle_delete" @click="handleClickDelSelected(item, index)" icon="icon-guanbi_dise iconfont" type="text">
                        </el-button>
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { GetDepartmentUserList, GetDepartmentList, PersonTagList } from "@/api/index.js";
export default {
    name: "userDepartmentPostSelection",
    props: {
        userDepartmentPostVisible: {
            type: Boolean,
            default: false,
        },
        userDepartmentPostTitle: {
            type: String,
            default: "选择",
        },
        selectType: {
            type: String,
            default: "departmentUserPost", // departmentUserPost =  部门人员岗位  departmentUser == 部门人员 user == 人员 departmentUserTag == 部门 人员 人员标签
        },
        userDepartmentPostSelected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localCheckStrictly: true,
            BtnDisabled: false,
            selectable_list: [],
            default_expanded: [],
            defaultProps: {
                children: "children",
                label: "relate_name",
            },
            keyWord: "",
            type: "department",
            postList: [
                { relate_id: 1, relate_name: "直属上级", relate_type: "3", relate_type_id: "1_3" },
                { relate_id: 2, relate_name: "部门负责人", relate_type: "3", relate_type_id: "2_3" },
                { relate_id: 3, relate_name: "普通员工", relate_type: "3", relate_type_id: "3_3" },
            ],
            userTagList: [],
            post_selected_ids: [],
            department_selected_list: [],
            user_selected_list: [],
            post_selected_list: [],
            tag_selected_ids: [],
            tag_selected_list: [],
        };
    },
    created() {
        if (this.userDepartmentPostSelected.length > 0) {
            this.user_selected_list = this.userDepartmentPostSelected.filter(
                (find) => find.relate_type == "App\\Models\\User"
            );
            this.department_selected_list = this.userDepartmentPostSelected.filter(
                (find) => find.relate_type == "App\\Models\\Department"
            );

            this.post_selected_list = this.userDepartmentPostSelected.filter((find) => find.relate_type == 3);
            this.post_selected_ids = this.post_selected_list.map((item) => {
                return item.relate_id;
            });

            this.tag_selected_list = this.userDepartmentPostSelected.filter(
                (find) => find.relate_type == "App\\Models\\UserTagRelate"
            );
            this.tag_selected_ids = this.tag_selected_list.map((item) => {
                return item.relate_id;
            });
        }
        if (this.selectType == "user") {
            this.type = "user";
            this.localCheckStrictly = false;
        }
        this.getDepartmentAndUserList();
    },
    methods: {
        handleClickTab(type) {
            this.type = type;
            if (type == "user") {
                this.localCheckStrictly = false;
            } else {
                this.localCheckStrictly = true;
            }
            this.getDepartmentAndUserList();
        },
        getDepartmentAndUserList() {
            if (this.type == "department") {
                GetDepartmentList({ keyword: this.keyWord }).then((res) => {
                    if (res.code === 200) {
                        this.selectable_list = res.data || [];
                        this.recursionAddRelateType(this.selectable_list);
                        this.$nextTick(() => {
                            this.department_selected_list.forEach((item) => {
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                            });
                        });
                    }
                });
            } else if (this.type == "user") {
                GetDepartmentUserList({ name: this.keyWord }).then((res) => {
                    if (res.code === 200) {
                        this.selectable_list = res.data || [];
                        this.recursionAddRelateType(this.selectable_list);
                        this.$nextTick(() => {
                            this.user_selected_list.forEach((item) => {
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                            });
                        });
                    }
                });
            } else if (this.type == "tag") {
                PersonTagList({ keyword: this.keyWord, page: 1, pageSize: 1000 }).then((res) => {
                    if (res.code === 200) {
                        let data = res.data.data || [];
                        data.forEach((item) => {
                            this.$set(item, "relate_id", item.id);
                            this.$set(item, "relate_name", item.name);
                            this.$set(item, "relate_type", "App\\Models\\UserTagRelate");
                            this.$set(item, "relate_type_id", item.relate_id + "_" + item.relate_type);
                        });
                        this.userTagList = data;
                    }
                });
            }
        },
        recursionAddRelateType(arr) {
            arr.forEach((item) => {
                item.relate_type_id = item.relate_id + "_" + item.relate_type;
                if (item.children && item.children.length > 0) {
                    this.recursionAddRelateType(item.children);
                }
            });
        },
        handleCheckNodeItem(data, { checkedKeys, checkedNodes }) {
            const dataIndex = checkedKeys.findIndex((check) => check === data.relate_type_id);
            if (dataIndex > -1) {
                let json = {
                    relate_type_id: data.relate_type_id,
                    relate_id: data.relate_id,
                    relate_name: data.relate_name,
                    relate_type: data.relate_type,
                };
                if (this.type == "department") {
                    this.department_selected_list.push(json);
                } else if (this.type == "user") {
                    const arr = this.findItemsWithType1(data);
                    arr.forEach((item) => {
                        if (
                            item.relate_type != "App\\Models\\Department" &&
                            this.user_selected_list.findIndex((user) => user.relate_type_id === item.relate_type_id) < 0
                        ) {
                            this.user_selected_list.push({
                                relate_type_id: item.relate_type_id,
                                relate_id: item.relate_id,
                                relate_name: item.relate_name,
                                relate_type: item.relate_type,
                            });
                        }
                        this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                    });
                }
            } else {
                if (this.type == "department") {
                    this.department_selected_list.splice(
                        this.department_selected_list.findIndex((item) => item.relate_type_id === data.relate_type_id),
                        1
                    );
                } else if (this.type == "user") {
                    const arr = this.findItemsWithType1(data);
                    arr.forEach((item) => {
                        if (
                            item.relate_type != "App\\Models\\Department" &&
                            this.user_selected_list.findIndex((user) => user.relate_type_id === item.relate_type_id) >
                                -1
                        ) {
                            this.user_selected_list.splice(
                                this.user_selected_list.findIndex(
                                    (user) => user.relate_type_id === item.relate_type_id
                                ),
                                1
                            );
                        }
                        this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
                    });
                }
            }
        },

        findItemsWithType1(obj) {
            let result = [];
            // 递归函数
            function traverse(obj) {
                result.push(obj);
                if (Array.isArray(obj.children)) {
                    obj.children.forEach((child) => {
                        traverse(child);
                    });
                }
            }
            traverse(obj);
            return result;
        },

        handleClickDelSelected(item, index) {
            if (this.type == "department") {
                this.department_selected_list.splice(index, 1);
                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
            } else if (this.type == "user") {
                this.user_selected_list.splice(index, 1);
                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
            } else if (this.type == "post") {
                this.post_selected_list.splice(index, 1);
                this.post_selected_ids = this.post_selected_list.map((map) => map.relate_id);
            } else if (this.type == "tag") {
                this.tag_selected_list.splice(index, 1);
                this.tag_selected_ids = this.tag_selected_list.map((map) => map.relate_id);
            }
        },
        // 选择岗位
        handleChangePost(value) {
            this.post_selected_list = [];
            this.postList.forEach((item) => {
                if (value.indexOf(item.relate_id) > -1) {
                    this.post_selected_list.push(item);
                }
            });
        },
        // 选择人员标签
        handleChangeTag(value, row) {
            if (value) {
                let json = {
                    relate_type_id: row.relate_type_id,
                    relate_id: row.relate_id,
                    relate_name: row.relate_name,
                    relate_type: row.relate_type,
                };
                this.tag_selected_list.push(json);
            } else {
                let index = this.tag_selected_list.findIndex((find) => find.relate_id == value);
                this.tag_selected_list.splice(index, 1);
            }
        },
        // 清除
        handleClickClearSelected(){
            this.post_selected_ids =  []
            this.post_selected_list =  []
            this.department_selected_list =  []
            this.user_selected_list =  []
            this.tag_selected_ids =  []
            this.tag_selected_list =  []
            if(this.$refs.dep_and_user_tree){
                this.$refs.dep_and_user_tree.setCheckedKeys([]);
            }
        },
        handleClickCancel() {
            this.$emit("update:userDepartmentPostVisible", false);
        },
        handleClickConfirm() {
            let selected_list = [
                ...this.department_selected_list,
                ...this.user_selected_list,
                ...this.post_selected_list,
                ...this.tag_selected_list,
            ];
            this.$emit("success", selected_list);
            this.$emit("update:userDepartmentPostVisible", false);
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input__suffix {
    top: 8px;
}
.user_department_wrap {
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: space-between;
}

.left_selectable_wrap {
    width: 50%;
    height: 100%;
    margin-right: 15px;
    border-radius: 6px;
    border: 1px solid #f3f3f3;
    display: flex;
    flex-direction: column;
    ::v-deep {
        .el-input--suffix {
            .el-input__suffix {
                top: 0;
                line-height: 32px;
            }
        }
    }

}

.right_selected_wrap {
    flex: 1;
    border-radius: 6px;
    border: 1px solid #f3f3f3;
    .title_wrap{
        display: flex;
        .title{
            display: flex;
            align-items: center;
            h5{
                font-size: 16px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                margin-right:4px ;
            }
            span{
                color: rgba(102, 102, 102, 1);
                font-size: 12px;
            }
        }
        .handle_clear{
            color: rgba(228, 65, 68, 1);
            font-size: 14px;
            cursor: pointer;
            &:hover{
                color: #e96769;
            }
            &:active{
                color: #b63436;
            }
        }
    }
}

.title_wrap {
    height: 40px;
    font-size: 16px;
    color: #333333;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 12px;
    & > span {
        flex: 1;
        max-width: 33.333%;
        text-align: center;
        display: block;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        position: relative;
        &.active {
            color: rgba(25, 144, 255, 1);
            font-weight: bold;
            border-bottom: 2px solid rgba(25, 144, 255, 1);
        }
    }
}
.check_box_block {
    flex: 1;
    overflow-y: auto;
    padding: 0 4px;
    box-sizing: border-box;
    width: 100%;
    ::v-deep .el-checkbox {
        display: block;
        line-height: 30px;
        overflow: hidden;
        margin-right: 0;
        padding: 0 12px;
        height:30px;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        box-sizing: border-box;
        .el-checkbox__label {
            flex: 1;
            flex-shrink: 0;
            display: flex;
            gap:10px;
            overflow: hidden;
            color: #666666;
            span:nth-child(1) {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #666666;
                font-weight: 400;
            }
            span:nth-child(2) {
                flex-shrink: 0;
                color: #666666;
                font-weight: 400;
            }
        }
        &.is-checked {
            .el-checkbox__label{
                color: rgba(51, 51, 51, 1);
            }
        }
        &:hover{
            background: rgba(0, 0, 0, 0.04);
        }
    }
}

.left_selectable_wrap .scroll_wrap {
    padding: 0 4px;
    margin-top: 8px;
    width: 100%;
    height: calc(100% - 105px);
    overflow-y: auto;
}

.right_selected_wrap .selected_list {
    width: 100%;
    height: calc(100% - 55px);
    padding: 0 4px;
    box-sizing: border-box;
    overflow-y: auto;
}

.right_selected_wrap .selected_list .selected_item {
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    margin-bottom: 4px;
    border-radius: 4px;
    color: rgba(102, 102, 102, 1);
}

.right_selected_wrap .selected_list .selected_item:hover {
    background: rgba(0, 0, 0, 0.04);
    color: rgba(51, 51, 51, 1);
}
.handle_delete{
    color: #bfbfbf;
    &:hover{
        color: #999;
    }
}
::v-deep .el-input__inner{
    padding: 0 32px 0 12px !important;
}
.icon-sousuo{
    color: rgb(102, 102, 102);
    cursor: pointer;
    margin-right: 6px;
}







::v-deep .el-tree-node__content{
    margin-bottom: 4px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
}
::v-deep .el-tree-node__content:hover, ::v-deep.el-upload-list__item:hover{
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.04);
    .el-checkbox .el-checkbox__inner{
        border-color: rgba(75, 162, 255, 1) !important;
    }
}

::v-deep .el-tree-node__content>.el-tree-node__expand-icon{
    color: rgba(102, 102, 102, 1);
    margin:0 8px 0 8px;
    padding: 2px;
    border-radius: 4px;

    &:hover{
        background: rgba(0, 0, 0, 0.04);
    }
}
::v-deep .el-tree-node__expand-icon.is-leaf{
    color: transparent !important;
    &:hover{
        background: transparent;
    }
}
</style>
